import React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import Navbar from "./Navbar";
import FleetManagement from "./FleetManagement";
import AboutCompany from "./AboutCompany";
import OurServices from "./OurServices";
import Contact from "./Contact";
import OurProduct from "./OurProduct";
import OurPartner from "./OurPartner";

const theme = createTheme({
  palette: {
    primary: {
      main: "#003B95",
    },
    secondary: {
      main: "#0066cc",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function App() {
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Navbar />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <FleetManagement />
                <AboutCompany />
                <OurServices />
                <Contact />
              </>
            }
          />
          <Route path="/about" element={<AboutCompany />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<OurServices />} />
          <Route path="/products" element={<OurProduct />} />
          <Route path="/partners" element={<OurPartner />} />
        </Routes>
      </ThemeProvider>
    </Router>
  );
}

export default App;
